import React, { useState, useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { Header } from "@components/templates";
import { Constants } from "@constants/index";
import { AppLoader } from "@genie-ui/react";
import { ACTIS_REPORTING, ActisReporting } from "@utils/js/actis";
import "./app.scss";
import { autoLogout } from "@utils/js/utilities";

const App = () => {
  const [currentUser, setCurrentUser] = useState({});
  const [error, setError] = useState(false);
  const isAccessDeniedPage = window.location.href.indexOf(Constants.ACCESS_DENIED) !== -1;
  ActisReporting.prototype.binder = { ...currentUser };

  useEffect(() => {
    if (currentUser?.userId) {
      requestAnimationFrame(() => {
        ACTIS_REPORTING.LOGIN.push({ ...Constants.ACTIS.EVENT_DATA.PAGE_LOAD });
      });
    }
  }, [currentUser]);

  useEffect(() => {
    const handleEvent = (eventData) => {
      if (eventData?.user) {
        setCurrentUser(eventData?.user);
      } else {
        setError(true)
      }
    };
    window.loginFromHtmlEmitter.addEventListener(handleEvent, "login");
    return () => {
      window.loginFromHtmlEmitter.removeEventListener(handleEvent, "login");
    };
  }, []);


  useEffect(() => {
    if (currentUser?.userId || error) {
      document.getElementById("delphi-html-loader").style.display = "none";
    }
    if (currentUser?.userId) {
      autoLogout();
    }
  }, [currentUser?.userId, error]);

  if (!currentUser?.userId && !isAccessDeniedPage) {
    return <AppLoader />;
  }

  return (
    <BrowserRouter basename={Constants.ROUTES.BASE_URL}>
      {!window.location.pathname.includes(Constants.ROUTES.MOBILE) ? (
        <div className="app-header-container">
          <Header currentUser={currentUser} error={error} />
        </div>
      ) : (
        <div className="app-header-container" />
      )}
    </BrowserRouter>
  );
};

export default App;
